import { useMatchProfileInfo } from "PFApp/hooks/use_match_profile_info";
import { Pill } from "PFComponents/pill";
import { SuspendedPill } from "PFComponents/suspended_pill";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useMatchCardContext } from "../../match_card_context";
import { MatchActivitySkills } from "../match_activity_skills";
import css from "./match_profile_info.module.scss";

export const MatchProfileInfo = () => {
  const { t } = useTranslation("activities");
  const { data: currentProfile } = useCurrentProfile();
  const { profile, isCompressed, creator, isUnbiasedMode, shortlist } = useMatchCardContext();
  const { headerInfo: headerProfileInfo } = useMatchProfileInfo(profile);
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const formattedHeaderProfileInfo = headerProfileInfo.map(({ value }) => value).join(", ");
  const suggestedBadgeLabel =
    shortlist?.suggested &&
    t(`parts.shortlistSuggested.${shortlist?.suggested}` as unknown as TemplateStringsArray);

  return (
    <div className={css.matchProfileInfo}>
      {!isUnbiasedMode ? (
        <span className={css.matchProfileHeader}>
          <Typography variant="h4" className={css.profileName}>
            {getProfileName(profile)}
          </Typography>
          {shortlist?.named && <Pill text={t("parts.namedResource")} small />}
          {!!suggestedBadgeLabel && <Pill text={suggestedBadgeLabel} small />}
          {!!profile.suspendedAt && <SuspendedPill suspendedAt={profile.suspendedAt} />}
        </span>
      ) : (
        <Typography variant="h4" className={css.profileName}>
          {getUnbiasedProfileName(profile, !!isUnbiasedMode)}
        </Typography>
      )}

      {formattedHeaderProfileInfo && (
        <Typography variant="labelRegular" className={css.customValues}>
          {formattedHeaderProfileInfo}
        </Typography>
      )}
      {creator && (
        <span className={css.addedBy}>
          <Typography withMargin variant="labelRegular">
            {t("show.shortlist.addedBy")}
          </Typography>
          <Typography withMargin variant="labelBold">
            <Link
              to={`/profiles/${creator.id === currentProfile.id ? "me" : creator.id}`}
              onClick={(event) => event.stopPropagation()}
            >
              {getProfileName(creator)}
            </Link>
          </Typography>
        </span>
      )}
      {!isCompressed && <MatchActivitySkills className={css.skills} />}
    </div>
  );
};
